// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import { installNativeValidationMessages } from "./lib/native_validation_messages"

installNativeValidationMessages()
